import React from 'react';
import { Platform } from 'react-native';
import Svg, { Path } from 'react-native-svg';

/**
 * Колокольчик уведомлений — один на всё приложение.
 *
 * <p>Рисованный, а не эмодзи: цветная 🔔 выпадала из шапки, где все значки тонируются одним
 * цветом темы. Вынесен из кнопки в строке чата, потому что тот же колокольчик понадобился в
 * шапке под «не беспокоить», а две копии одной кривой расходятся при первой же правке.
 *
 * <p>Перечёркивание рисует вызывающий: в строке чата это полоска поверх значка из палитры
 * (`notifyMutedSlashLine`), в шапке — своя, вдвое меньше. Класть её сюда значило бы принести
 * с собой и размер, и цвет, которых у значка не одно значение.
 */
export function BellGlyph({
  size = 20,
  color,
  strokeWidth = 1.8,
}: {
  size?: number;
  color: string;
  /** Толщина в единицах viewBox: мелкий значок с толщиной крупного выглядит выцветшим. */
  strokeWidth?: number;
}) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...(Platform.OS === 'web' ? {} : { accessibilityElementsHidden: true })}>
      <Path
        d="M12 3.2a5.4 5.4 0 0 0-5.4 5.4v2.7c0 .9-.36 1.77-1 2.4l-.8.8a.9.9 0 0 0 .64 1.54h13.12a.9.9 0 0 0 .64-1.54l-.8-.8a3.4 3.4 0 0 1-1-2.4V8.6A5.4 5.4 0 0 0 12 3.2Z"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <Path
        d="M10.2 18.4a1.85 1.85 0 0 0 3.6 0"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </Svg>
  );
}
